import { Button, Box, Typography } from "@mui/material";
import autoIcono from "../images/auto-icono.png";

const stripe = "#003E7E";
const lightGrey = "#D9D9D9";
const darkGrey = "#6F6D70";

const PositionButton = ({ number, enabled, onClick }) => {
  const bg = enabled ? lightGrey : darkGrey;

  return (
    <Button
      fullWidth
      disableRipple
      disabled={!enabled}
      onClick={onClick}
      sx={{
        height: 40,
        padding: 0,
        minWidth: 0,
        textTransform: "none",
        backgroundColor: "transparent",
        justifyContent: "flex-start",
        boxShadow: "none",
        "&:hover": { backgroundColor: "transparent" },
      }}
    >
      {/* banda azul */}
      <Box
        sx={{
          width: 36,
          alignSelf: "stretch",
          bgcolor: stripe,
          borderRadius: "8px 0 0 8px",
        }}
      />

      {/* bloque gris */}
      <Box
        sx={{
          flexGrow: 1,
          height: "100%",
          bgcolor: bg,
          borderRadius: "0 8px 8px 0",
          display: "flex",
          alignItems: "center",
          pl: 2,
          pr: 3,
        }}
      >
        {/* ------------  PNG del auto  ------------ */}
        <Box
          component="img"
          src={autoIcono}
          alt=""
          sx={{
            width: 40,
            transform: "rotate(90deg)",
            marginRight: 5,
            opacity: enabled ? 1 : 0.85,
            filter: enabled ? "none" : "grayscale(80%)",
          }}
        />

        {/* texto */}
        <Typography sx={{ color: "#4f4e53", fontWeight: "bold", letterSpacing: 0.5 }}>POSICIÓN&nbsp;{number}</Typography>
      </Box>
    </Button>
  );
};

export default PositionButton;
